import React from 'react';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useAnalytics } from '../hooks/useAnalytics';

const AnalyticsDashboard = ({ workspaceId }) => {
  const { dashboardData, loading, error } = useAnalytics(workspaceId);

  if (loading) return <Typography>Loading dashboard...</Typography>;
  if (error) return <Typography color="error">Error: {error.message}</Typography>;
  if (!dashboardData) return null;

  // Transform data for charts
  const eventCountsData = dashboardData.eventCounts?.map(item => ({
    name: item.eventType,
    count: item._count.eventType
  }));

  const dailyMetricsData = dashboardData.dailyMetrics?.map(item => ({
    date: new Date(item.date).toLocaleDateString(),
    [item.metricType]: item.metricValue
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Analytics Dashboard
      </Typography>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom>
                Active Sessions
              </Typography>
              <Typography variant="h4">
                {dashboardData.activeSessions || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {eventCountsData?.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Event Counts by Type
            </Typography>
            <div style={{ height: 300 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={eventCountsData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="count" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
      )}

      {dailyMetricsData?.length > 0 && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Daily Metrics
            </Typography>
            <div style={{ height: 300 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={dailyMetricsData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  {dailyMetricsData[0] && Object.keys(dailyMetricsData[0])
                    .filter(k => k !== 'date')
                    .map((metric, i) => (
                      <Bar 
                        key={metric}
                        dataKey={metric} 
                        fill={`#${Math.floor(Math.random()*16777215).toString(16)}`}
                      />
                    ))
                  }
                </BarChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default AnalyticsDashboard;